<template>
  <div
    class="flex w-100 z-index-5 pos-fixed w-100"
    style="pointer-events: none"
  >
    <header
      ref="headerRef"
      class="z-index-5 w-100 flex flex-justify-between flex-nowrap pd-small flex-v-center"
      :class="
        headerTheme === 'dark' ? 'br-b-black-transp-10' : 'br-b-white-transp-10'
      "
      style="pointer-events: auto"
    >
      <div class="flex flex-align-center gap-thin">
        <router-link class="header-logo" to="/" aria-label="Commune Home">
          <img
            class="h-1r"
            :src="
              headerTheme === 'dark'
                ? '/logo/logotype-black.svg'
                : '/logo/logotype-white.svg'
            "
            alt="Commune"
          />
        </router-link>
      </div>

      <nav
        class="flex-align-center gap-thin flex mobile:d-none tablet:d-none"
        :class="headerTheme === 'dark' ? 't-black' : 't-white'"
      >
        <!-- <router-link
          class="fw-medium uppercase"
          :class="headerTheme === 'dark' ? 't-black' : 't-white'"
          to="/about"
        >
          Our Story
        </router-link>
        <router-link
          class="fw-medium uppercase"
          :class="headerTheme === 'dark' ? 't-black' : 't-white'"
          to="/menu"
        >
          Food&Drinks
        </router-link> -->
        <!-- <router-link
          class="fw-medium uppercase"
          :class="headerTheme === 'dark' ? 't-black' : 't-white'"
          to="/nightlife"
        >
          Nightlife
        </router-link> -->
      </nav>

      <div class="flex flex-align-center gap-thin mobile:d-none tablet:d-none">
        <a
          href="https://maps.app.goo.gl/oQEKmkBKaMqpQfqK8"
          target="_blank"
          rel="noopener noreferrer"
          class="bg-blur-small pd-thin pd-l-small pd-r-small radius-thin fw-medium uppercase footnote flex flex-align-center gap-thin"
          :class="
            headerTheme === 'dark'
              ? 't-black bg-black-transp-10'
              : 't-white bg-white-transp-10'
          "
        >
          <svg class="i-small" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          <span :class="headerTheme === 'dark' ? 't-black' : 't-white'">
            Get Direction
          </span>
        </a>
      </div>

      <button
        @click="toggleMobileMenu"
        class="burger-btn d-none mobile:d-flex tablet:d-flex flex-column flex-align-center flex-justify-center"
        :class="[
          { 'burger-open': isMobileMenuOpen },
          headerTheme === 'dark' ? 'burger-dark' : '',
        ]"
        aria-label="Open menu"
        :aria-expanded="isMobileMenuOpen"
      >
        <span class="burger-line"></span>
        <span class="burger-line"></span>
        <span class="burger-line"></span>
      </button>
    </header>
  </div>

  <div
    class="mobile-menu pos-fixed pos-t-0 pos-r-0 pos-b-0 pos-l-0 bg-black z-index-10 flex flex-column flex-align-center flex-justify-center"
    :class="{ 'mobile-menu-open': isMobileMenuOpen }"
  >
    <button
      @click="toggleMobileMenu"
      class="mobile-menu-close pos-absolute pos-t-small pos-r-small w-3r h-3r flex flex-align-center flex-justify-center z-index-10"
      aria-label="Close menu"
    >
      <svg
        class="w-2r h-2r"
        fill="none"
        viewBox="0 0 24 24"
        stroke="white"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>

    <nav class="mobile-nav flex flex-column gap-extra flex-align-center">
      <!-- <router-link
        @click="toggleMobileMenu"
        class="mobile-menu-link fw-regular t-extra uppercase fw-medium"
        to="/about"
      >
        <span class="h2 t-white">Our Story</span>
      </router-link>
      <router-link
        @click="toggleMobileMenu"
        class="mobile-menu-link fw-regular t-extra uppercase fw-medium"
        to="/menu"
      >
        <span class="h2 t-white">Food&Drinks</span>
      </router-link> -->
      <!-- <router-link
        @click="toggleMobileMenu"
        class="mobile-menu-link fw-regular t-extra uppercase fw-medium"
        to="/nightlife"
      >
        <span class="h2 t-white">Nightlife</span>
      </router-link> -->
    </nav>

    <a
      href="https://maps.app.goo.gl/oQEKmkBKaMqpQfqK8"
      target="_blank"
      rel="noopener noreferrer"
      class="mobile-menu-cta mn-t-extra br-1px br-white-transp-20 pd-medium radius-thin fw-medium uppercase flex flex-align-center gap-small"
    >
      <svg class="i-regular" fill="none" viewBox="0 0 24 24" stroke="white" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
      <span class="t-white">Get Direction</span>
    </a>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const headerTheme = computed(() => route.meta?.header_theme || "light");
const headerRef = ref(null);
const isMobileMenuOpen = ref(false);

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
};

onMounted(() => {
  let lastScrollY = 0;
  let ticking = false;
  const scrollview = document.querySelector("#scrollview");

  const updateHeader = () => {
    const header = headerRef.value;
    if (!header || !scrollview) return;

    const scrollY = scrollview.scrollTop;

    if (scrollY > 0) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }

    if (scrollY > lastScrollY && scrollY > 200) {
      header.classList.add("hidden");
    } else {
      header.classList.remove("hidden");
    }

    lastScrollY = scrollY;
    ticking = false;
  };

  const handleScroll = () => {
    if (!ticking) {
      requestAnimationFrame(updateHeader);
      ticking = true;
    }
  };

  if (scrollview) {
    scrollview.addEventListener("scroll", handleScroll, { passive: true });
  }
});
</script>

<style lang="scss" scoped>
header {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &.scrolled {
    background: rgba(0, 0, 0, 0.95) !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  }

  &.hidden {
    transform: translateY(-100%);
  }
}

.burger-btn {
  width: 2.5rem;
  height: 2.5rem;
  gap: 5px;
}

.burger-line {
  width: 1.5rem;
  height: 2px;
  background: white;
}

.burger-dark .burger-line {
  background: black;
}

.mobile-menu {
  pointer-events: none;
  opacity: 0;
  transform: translateX(100%);
  transition: 
    transform 0.4s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  &.mobile-menu-open {
    pointer-events: auto;
    opacity: 1;
    transform: translateX(0);
  }
}

.mobile-menu-close {
  opacity: 0;
  transform: rotate(-90deg);
  transition: 
    opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s,
    transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s;
  
  .mobile-menu-open & {
    opacity: 1;
    transform: rotate(0);
    transition-delay: 0.2s;
  }
}

.mobile-nav .mobile-menu-link:nth-child(1) {
  transition-delay: 0s;
}

.mobile-nav .mobile-menu-link:nth-child(2) {
  transition-delay: 0s;
}

.mobile-nav .mobile-menu-link:nth-child(3) {
  transition-delay: 0s;
}

.mobile-menu-open .mobile-nav .mobile-menu-link:nth-child(1) {
  transition-delay: 0.1s;
}

.mobile-menu-open .mobile-nav .mobile-menu-link:nth-child(2) {
  transition-delay: 0.2s;
}

.mobile-menu-open .mobile-nav .mobile-menu-link:nth-child(3) {
  transition-delay: 0.3s;
}

.mobile-menu-link {
  opacity: 0;
  transform: translateY(30px);
  transition: 
    opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  .mobile-menu-open & {
    opacity: 1;
    transform: translateY(0);
  }

  span {
    display: inline-block;
    transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &:hover span {
    transform: scale(1.05);
  }
}

.mobile-menu-cta {
  opacity: 0;
  transform: translateY(20px);
  transition: 
    opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1) 0s,
    transform 0.4s cubic-bezier(0.4, 0, 0.2, 1) 0s;

  .mobile-menu-open & {
    opacity: 1;
    transform: translateY(0);
    transition-delay: 0.4s;
  }
}

.page-header {
  display: flex;
  position: fixed;
  background: transparent;
  flex-wrap: wrap;
  width: 100%;
  height: 4rem;
  top: 0;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  .header-logo img {
    height: 1rem;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .field-wrapper:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  ul li {
    color: black;
  }

  &.animated-header {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    &.scrolled {
      background: rgba(0, 0, 0, 0.95);
      height: 4rem;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);

      .header-logo img {
        height: 0.6rem;
      }

      nav a {
        color: white !important;
      }
    }

    &.hidden {
      transform: translateY(-100%);
    }
  }
}
</style>